// Client for pilot-focus APIs: module visibility, Actual valuation, data-origin status.
const BACKEND = process.env.REACT_APP_BACKEND_URL;

async function j(method, path, { body, actor } = {}) {
  const res = await fetch(`${BACKEND}/api${path}`, {
    method,
    headers: {
      ...(body ? { "Content-Type": "application/json" } : {}),
      ...(actor ? { "X-Actor": actor.employeeId || "", "X-Actor-Role": actor.role || "" } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  const text = await res.text();
  let payload = null;
  try { payload = text ? JSON.parse(text) : null; } catch { payload = null; }
  if (!res.ok) {
    const d = payload?.detail;
    const err = new Error(Array.isArray(d) ? d.map(x => x.msg).join("; ") : d || `HTTP ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return payload;
}

export const getModuleVisibility = () => j("GET", "/modules/visibility");
export const getModuleCatalog = (actor) => j("GET", "/modules/catalog", { actor });
export const setModuleVisibility = (path, visible, reason, actor) =>
  j("PUT", "/modules/visibility", { body: { path, visible, reason }, actor });
export const applyPilotPreset = (reason, actor) => j("POST", "/modules/apply-preset", { body: { reason }, actor });
export const getModuleHistory = (actor, limit = 50) => j("GET", `/modules/history?limit=${limit}`, { actor });

export const getActualValuation = () => j("GET", "/inventory/valuation/actual");
export const getDataOriginStatus = () => j("GET", "/data-origin/status");
